/**
 * Formats an array of quality defects from the API.
 *
 * @param {Array} qualityDefectsFromApi - The array of quality defects from the API.
 * @returns {Array} An array of formatted quality defects.
 *
 * Each quality defect object in the input array should have the following properties:
 * - id: {string|number} The unique identifier of the quality defect.
 * - name: {string} The name of the quality defect.
 * - code: {string} The code of the quality defect.
 * - description: {string} [Optional] The description of the quality defect.
 *
 * If the input is not a valid array or is empty, the function will return an empty array.
 * If any quality defect object in the input array is not valid, it will be skipped and an error will be logged to the console.
 */
export function formatQualityDefects(qualityDefectsFromApi) {
    if (
        !qualityDefectsFromApi ||
        !Array.isArray(qualityDefectsFromApi) ||
        !qualityDefectsFromApi.length
    ) {
        return [];
    }

    const formattedQualityDefects = [];

    qualityDefectsFromApi.forEach(qualityDefect => {
        if (!qualityDefect || typeof qualityDefect !== 'object') {
            console.error('Quality defect is not an object', qualityDefect);
            return;
        }

        // The quality defect must have an id, name, and code
        if (!qualityDefect.id || !qualityDefect.name || !qualityDefect.code) {
            console.error(
                'Quality defect is missing required fields',
                qualityDefect
            );
            return;
        }

        // format quality defect
        formattedQualityDefects.push({
            id: qualityDefect.id,
            name: qualityDefect.name,
            code: qualityDefect.code,
            description: qualityDefect.description || ''
        });
    });

    return formattedQualityDefects;
}
